import { z } from 'zod';
import { ensureOBSMinVersion } from '../utils/ensureOBSPresence';

export const allowedProviders = ['twitch', 'youtube', 'trovo', 'x', 'kick'] as const;
export const allowedConnectOptions = [...allowedProviders, 'tiktok', 'custom'] as const;
export const allowedProvidersSchema = z.enum(allowedProviders);
export const allowedConnectOptionsSchema = z.enum(allowedConnectOptions);

export const ALWAYS_ENABLE_FEATURES_SELIVE_VERSIONS = {
  // feature: [ major, minor, patch, build ],
};

export type AllowedProvider = (typeof allowedConnectOptions)[number] | 'kick';

export const providersOrder = [
  'twitch',
  'youtube',
  'kick',
  'tiktok',
  'x',
  'custom',
  /* 'trovo', */
] as AllowedProvider[];

export const platformPrettyName: Record<AllowedProvider, string> = {
  twitch: 'Twitch',
  youtube: 'YouTube',
  trovo: 'Trovo',
  x: 'X (Twitter)',
  tiktok: 'Tiktok',
  kick: 'Kick',
  custom: 'Custom RTMP',
};

export async function getIsKickEnabled() {
  const { seLiveMultiStreamingMinVersionOk: isKickEnabled } = await ensureOBSMinVersion({
    minVersion: [25, 1, 9, 335],
  });

  return isKickEnabled;
}

export async function getIsEncoderSettingsEnabled() {
  const { seLiveMultiStreamingMinVersionOk: isEncoderSettingsEnabled } = await ensureOBSMinVersion({
    minVersion: [25, 2, 28, 434],
  });

  return isEncoderSettingsEnabled;
}

export async function getIsEncoderPropertiesQueryEnabled() {
  const { seLiveMultiStreamingMinVersionOk: isEncoderPropertiesQueryEnabled } = await ensureOBSMinVersion({
    minVersion: [25, 3, 5, 435],
  });

  return isEncoderPropertiesQueryEnabled;
}

export async function getIsOutputVideoEncoderOverrideEnabled() {
  const { seLiveMultiStreamingMinVersionOk: isOutputVideoEncoderOverrideEnabled } = await ensureOBSMinVersion({
    minVersion: [25, 3, 6, 438],
  });

  return isOutputVideoEncoderOverrideEnabled;
}

export async function getIsReplayBufferEnabled() {
  const { seLiveMultiStreamingMinVersionOk: isReplayBufferEnabled } = await ensureOBSMinVersion({
    minVersion: [25, 4, 24, 477],
  });

  return isReplayBufferEnabled;
}

export async function getIsTransitionsEnabled() {
  const { seLiveMultiStreamingMinVersionOk: isTransitionsEnabled } = await ensureOBSMinVersion({
    minVersion: [25, 5, 21, 479],
  });

  return isTransitionsEnabled;
}

export async function getIsHotkeyServiceEnabled() {
  const { seLiveMultiStreamingMinVersionOk: isHotkeyServiceEnabled } = await ensureOBSMinVersion({
    minVersion: [25, 4, 5, 467],
  });

  return isHotkeyServiceEnabled;
}

export async function getIsObsLoadedModulesCheckEnabled() {
  const { seLiveMultiStreamingMinVersionOk: isObsLoadedModulesCheckEnabled } = await ensureOBSMinVersion({
    minVersion: [25, 4, 5, 467],
  });

  return isObsLoadedModulesCheckEnabled;
}

export async function getIsSharedVideoCompositionsEnabled() {
  const { seLiveMultiStreamingMinVersionOk: isFeatureEnabled } = await ensureOBSMinVersion({
    minVersion: [25, 10, 9, 516],
  });

  return isFeatureEnabled;
}

export async function getIsVideoEncoderScalingEnabled() {
  const { seLiveMultiStreamingMinVersionOk: isFeatureEnabled } = await ensureOBSMinVersion({
    minVersion: [25, 10, 26, 520],
  });

  return isFeatureEnabled;
}
